module.exports = __webpack_public_path__ + "assets/img/goods-discount-bg.5191581b.png";